import enLocale from "element-ui/lib/locale/lang/es";
import { performanceEs } from "../temp/performance-es";
import trans from "@/doc/lang/_es.json";
import hom from "@/doc/hom/_es.json";
import { langEs } from "../lgyLangs/es";
import { fhbLangEs } from "../fhbLangs/es";
import { lssLangEs } from "../lssLangs/es";
import { wrhLangEs } from "../wrhLangs/es";
import { lxyLangEs } from "../lxyLangs/es";
import { DyLangEs } from "../DyLangs/es";


const es = {
  normal: "Normal",
  outsourcing: "Subcontratación",
  English: "Inglés",
  española: "Español",
  India: "Hindi",
  authority: {
    authorityManagement: "Administración de permisos",
    createNewUser: "Crear nuevo usuario",
    enterName: "Ingresa el nombre",
    enterEmail: "Ingresa el correo ",
    enterRole: "Ingresa el Rol ",
    enterCountry: "Ingresa el país",
    enterID: "Ingresa el ID del empleado",
    enterPassword: "Ingresa la contraseña ",
    password: "Contraseña ",
    modifyPassword: "Modifica la contraseña",
    oldPassword: "Contraseña anterior",
    newPassword: "nueva contraseña",
    confirmPassword: "confirma la contraseña",
    confirmTheChanges: "Confirma los cambios",
    ifForgotContactLeader:
      "Si te olvidas la contraseña, por favor que contactes a tu TL",
    disaccordWithThFirsPassword: "desacuerdo con la primera contraseña",
    passwordRules:
      "La contraseña debe incluir letra mayúscula y minúscula, número y puntuaciones ,no contienen nombre de usuario,8 caracteres como mínimo",
    name: "Nombre",
    email: "Correo ",
    role: "Rol ",
    country: "País",
    operator: "Operador",
    operate: "funcionar",
    Disable: "Desactivar",
    Enable: "Inhabilitar",
    enableGoogleVerification: "Activar verificación de Google ",
    requiredFields: "Campos requeridos ",
    pleaseFillInCorrectly: "Por favor rellena correctamente",
    edit: "Editar ",
    delete: "Eliminar ",
    add: "Añadir",
    confirmDelete: "¿Seguro quieres eliminar? ",
    cancel: "Cancelar ",
    ok: "Confirmar",
    search: "Buscar",
    operateTime: "Tiempo de operación ",
    roleManagement: "Administración de roles",
    containsSubordinateLevelsAndCannotBeDeleted:
      "Contiene niveles subordinados y no puede ser eliminado ",
    addaFirstLevelRole: "Añadir un rol de primer nivel",
    roleRightsManagement: "Administración de permisos de los roles",
    permissionAssignment: "Asignación de permisos ",
    operationAuthority: "Permiso de operación ",
    dataAuthority: "Permiso de datos",
    pleaseEnteraKeyword: "Ingresar palabra clave ",
    passwordVerification:
      "La contraseña tiene que incluir mayúsculas y minúsculas, números y símbolos y no puedes usar tu nombre como contraseña ",
    passwordDoesNotContainCapitalLettersPleaseFillInAgain:
      "La contraseña no contiene mayúsculas, por favor rellena de nuevo ",
    passwordDoesNotContainLowercaseLettersPleaseFillInAgain:
      "La contraseña no contiene minúsculas, por favor rellena de nuevo ",
    thePasswordDoesNotContainNumbersPleaseFillInAgain:
      "La contraseña no contiene números, por favor rellena de nuevo ",
    passwordDoesNotContainCharactersPleaseFillInAgain:
      "La contraseña no contiene símbolos, por favor rellena de nuevo ",
    cantUseYourNameAsPasswordPleaseFillInAgain:
      "No se permite usar tu nombre como contraseña ",
    repeatPasswordPleaseFillInAgain:
      "Contraseña duplicada, por favor que ingresa de nuevo ",
    disaccordWithTheFirstPassword: "desacuerdo con la primera contraseña",
    mailboxAlreadyExistsPleaseFillInAgain:
      "El correo ya existe, por favor ingrese de nuevo ",
    theRoleContainsUsersAndCannotBeDeleted:
      "El rol contiene usuarios y no puede ser eliminado ",
    roleGroupManagement: "Administración de grupos de roles ",
    roleGroup: "Grupos de roles",
    createGroup: "Crear un grupo ",
    groupRoleAddedSuccessfully: "Rol de grupo añadido exitosamente ",
    roleExistsInRoleGroupDeletionFailed:
      "El rol existe en el grupo de roles, no se puede eliminar ",
    groupPermissionManagement: "Administración de permisos del grupo",
    permissionAssignmentSucceeded: "Permiso asignado exitosamente "
  },
  collectWorkOrders: {
    collectWorkOrders: "Casos de cobranza ",
    ticketAtttibuteConfiguration: "Configuración de casos",
    singlePeriodDays: "Periodo simple (días) ",
    installmentDays: "Pago parcial (días) ",
    delete: "Eliminar ",
    save: "Guardar ",
    addCustomWorkOrderLevels: "Añadir nivel de órdenes de trabajo",
    areYouSureToDelete: "¿Seguro que quieres borrar? ",
    cancel: "Cancelar",
    confirm: "Confirmar",
    deleteAll: "Eliminar todo",
    edit: "Editar",
    pleaseSetaCoherentLevel: "Por favor elige un nivel coherente",
    pleaseSetaDifferentLevel: "Por favor elige un nivel diferente"
  },
  performance: {
    rollfinishnum: 'Roll Finish Num',
    performanceReport: "Reporte de rendimiento",
    staffPerformance: "Rendimiento del personal",
    ticketCategory: "Clasificación de cartera",
    role: "Rol",
    time: "Tiempo",
    staff: "Empleado",
    email: "Email",
    search: "Buscar",
    clear: "Borrar",
    refresh: "Actualizar",
    export: "Exportar",
    date: "Fecha",
    ranking: "Ranking",
    totalLeftUnpaidPrincipal: "Monto total",
    repayPrincipal: "Pago principal de devolución",
    repayInterest: "Interés sobre devolución",
    totalRepayAmount: "Cantidad total de devolución",
    repayRate: "Porcentaje de devolución",
    targetRepayRate: "Porcentaje de meta de devoluciones",
    diffTargetRepayAmount: "Diferencia del importe",
    newAssignNum: "Nuevo número asignado",
    handleTimes: "Numero de gestiones",
    handleNum: "Cuentas tocadas",
    completeNum: "Número de procesos terminados",
    loadNum: "Número asignado",
    performanceComparison: "Comparativo de rendimiento",
    type: "Tipo",
    belongedGroup: "Grupo",
    staffOptional: "Empleado (opcional) ",
    pleaseChoose: "Por favor elija ",
    YesNoLastorderrule: "Sí / No Último pedido",
    byStaff: "por empleado",
    byGroup: "por rol",
    byGroup1: "por rol",
    byGroup2: "por grupo",
    byGroup3: "OM",
    pleaseChooseaRole: "por favor elige un rol",
    noStaffsUnderThisGroupWereFoundPleaseConfirmWhetherTheGroupAndStaffMatches:
      "No se encontró ningún registro, por favor confirme que el trabajador o equipo están registrados",
    dashboard: "tablero",
    groupTotalRepayAmount: "Cantidad total de devoluciones del grupo",
    groupRepayRate: "Porcentaje de devoluciones del grupo",
    groupKPI: "KPI del grupo",
    groupCompleteNum: "Número de casos completados del grupo",
    groupRanking: "Ranking del grupo",
    group: "Grupo",
    staffRanking: "Ranking de empleado",
    name: "Nombre",
    newtab: "Se abre una nueva pestaña",
    extensionFeeToNewOrde: "Pago para la nueva extensión",
    numberApplicationsRolloverOrders:'Número de solicitudes de órdenes de renovación',
    totalExtensionRepaymentAmount: "Monto total de pago de extensión",
    waiveOffAmount: "Monto reducido",
    waiveOffNum: "número de reducción",
    bonusAmount: "Bono",
    completeLabel: "Performance completed",
    completed: "Complete",
    inCompleted: "Incompleto",
    repayAmount: 'Jumlah koleksi',
    repayTime: 'Waktu masuk bank',
    notifyTime: 'Waktu pemberitahuan bank',
    jsIndex: 'Nomor seri',
    businessTime: 'Waktu pemberitahuan parti bisnis',
    answerNum: 'Carteras contactada',
    answerTimes: 'Número de marcaciones ',
    pstClosureNum: 'Número de ventas',
    closureAmount: 'Rotación',
    pstClosureAmount: 'Rotación de ventas',
    conversionRate: 'Tasa de conversión',
    closureRate: 'Tasa de transacción',
    closureNum: 'Finalizada volumen'
  },
  performance2: {
    bucket: "Bucket",
    fecha: "Fecha",
    avgcalltime: "Gestiones",
    difcalltime: "Dif Gestiones",
    avgrepayrate: "% Rec",
    hourlyachievementsents: "Dif % Rec",
    totalallocationamount: "Mongto Asignado",
    totalrepayamount: "Mongto Recuperado",
    hourlytarget: "Meta",
    completerate: "%Cump"
  },
  orderInfo: {
    BadDebts: "Bad debts",
  },
  ticket: {
    ExportEmail: "Exportar lista de correos",
    Email: "Buzón",
    normal: 'normal',
    abnormal:'abnormal',
    PaymentCodeStatus: "estado de ref.de pago",
    PaymentCodeAmount: "monto de ref.de pago",
    PaymentCode: "referencia de pago",
    ThirdPartyName: "nombre de intermediaria",
    Mobile: "Número de celular",
    VA: "VA",
    OXXOCode: "Referencia de OXXO",
    PaynetCode: "Referencia de Paynet",
    AccountId: "ID de usuario",
    InvalidTime: "tiempo vencido",
    RemainingAmount: "monto de pago",
    collectTicketSystem: "Sistema de cobranza",
    systemManager: "Manajemen Tiket ",
    ticketID: "ID Tiket ",
    loanID: "ID de préstamo ",
    userID: "ID de Usuario ",
    caseID: "ID de caso ",
    ticketAssignToName: "Asignar a (nombre) ",
    ticketAssignToId: "Asignar a (ID) ",
    ticketCreateTime: "Tiempo de creación ",
    completeTime: "Tiempo de finalización ",
    closeTime: "Tiempo de cierre ",
    assignTime: "Tiempo asignado ",
    ticketStatus: "Estado ",
    orderStatus: "Estado de la orden ",
    ticketCategory: "Clasificaciòn de reserva ",
    search: "Buscar ",
    batchAssign: "Asignación masiva ",
    emailNameExport: "Exportación de lista de Email",
    batchRecover: "Recuperacíon masiva ",
    batchOutsourcing: "Subcontratación masiva ",
    batchRecall: "lote reciclado autocolección",
    dataExport: "Exportar",
    manualUpgrade: "Actualización manual",
    handleTime: "Número de procesamientos ",
    lastCommunicationResult: "Tiempo de ultimo procesamiento ",
    nextCommunicationResult: "Tiempo de la comunicación ",
    partialCompleteTime: "Tiempo de finalización parcial ",
    expirationTime: "Tiempo de vecimiento ",
    operation: "Operar ",
    attributeConfigure: " Propiedades de configuración ",
    ticketBasicAttribute: "Propiedades basicas de Reserva ",
    attributeNumber: "ID de propiedades  ",
    attributeName: "nombre de propiedades  ",
    foundTime: "Tiempo de creación",
    ticketCombineAttribute: "Propiedad combinada de Reserva ",
    newAttributeValueOperation: "Operación de propiedades + valores nuevos ",
    newCombineAttributeOperation: "Operación de propiedades combinadas nuevas ",
    combineName: "nombre de propiedades combinadas  ",
    attributeOne: "Propiedad Uno  ",
    calculate: "Calcular ",
    value: "Valor ",
    attributeDetails: "detalle de Propiedades  ",
    updateTime: "Tiempo de actualización ",
    edit: "Editar ",
    loadAttributeConfigure: "Cargo Propiedades de configuración ",
    loadAttributeName: "Nombre de Valor de atributo ",
    attributeType: "Tipo de Valor de atributo ",
    combineAttributeNumber: "numerar propiedad combinada ",
    attributeValue: "Valor de atributo ",
    newTicket: "Nueva reserva ",
    oldTicket: "Reserva pasada ",
    completeTicket: "Reserva terminada ",
    telephone: "Teléfono ",
    customerName: "Nombre de cliente ",
    dailyCollectionTimes: "Veces diarias de cobrar ",
    collectionTimes: "Veces de cobrar ",
    lastCollectionTime: "Tiempo de ulitima cobra ",
    lastCollectionRecord: "Nota de ulitima cobra ",
    promiseToPayTime: "Tiempo de PTP ",
    customerType: "Tipo de cliente ",
    overdueDays: "Días vencidos ",
    timeSinceLastProcessing: "Tiempo para el procesamiento ",
    collection: "Cobranza ",
    ticketInfo: "Datos de reserva ",
    warning: "Under Investigation. Stop calling to this customer!", // 英语
    LatestPromisedRepaymentTime: "Tiempo de promesa ",
    customerDetailInformation: "Informacion sobre cliente ",
    SMS: "Mensaje ",
    SMSContext: "Contexto SMS",
    sendMessageToCustomer: "Enviar mensaje al cliente ",
    sendMessageToCustomer2: "Manda mensaje al segundo número",
    sendMessageToContactOne: "Enviar mensaje a la referencia 1 ",
    sendMessageToContactTwo: "Enviar mensaje a la referencia 2 ",
    sendMessageToContactThree: "Enviar mensaje a la referencia 3",
    selectMessage: "Elige el modelo de mensaje ",
    selectWAMessage: "Por favor seleccione una plantilla",
    send: "Enviar ",
    phone: "Teléfono ",
    phoneTwo: "segundo número",
    contact1phone: "Número de referencia 1 ",
    relationship: "Relación ",
    name: "Nombre ",
    contact2phone: "Número de referencia 2 ",
    contact3phone: "Número de referencia 3 ",
    familyPhone: "Teléfono Fijo ",
    autoCallResult: "Resultado de autocall ",
    logCollectionDetails: "Resultado de cobra ",
    relief: "Deducir ",
    contactWay: "Contacto ",
    contactTime: "Tiempo de llamada ",
    targetContact: "Objeto de llamada ",
    connection: "Situación de conectar ",
    willingnessToPay: "Voluntad de pago ",
    overdueReason: "Razón de vencimiento ",
    collectionResult: "Resultado de cobra ",
    remark: "Nota ",
    saveCollectionDetail: "Guardar el historal de cobra ",
    repaymentInfo: "Información de pago ",
    VAaccount: "Usuario de VA ",
    marketPayAmount: "monto actual de la referencia de pago",
    OXXOMarketPaymentCode: "Referencia de  OXXO ",
    PaynetMarketPaymentCode: "Referencia de  Paynet",
    paymentlink: 'Link de Pago',
    remainingAmountDue: "el resto del pago ",
    OXXOMarketPaymentCodeAmount: "Monto de pago por OXXO (incluye de comisión ",
    PaynetMarketPaymentCodeAmount:
      "Monto de pago por Paynet (incluye de comisión ",
    refreshOXXOMarketPaymentCode: "actualizar clave",
    GetReference: 'Obtener código de pago',
    OXXONeedFee: "si eliges OXXO pay, tienes que pagar comisión",
    PaynetNeedFee: "si eliges Paynet pay, tienes que pagar comisión",
    PaycashNeedFee: "si eliges Paycash pay, tienes que pagar comisión",
    BalotoNeedFee: "si eliges Vía Baloto pay, tienes que pagar comisión",
    EfectyNeedFee: "si eliges Efecty pay, tienes que pagar comisión",
    BancolombiaNeedFee: "si eliges Bancolombia pay, tienes que pagar comisión",
    HandlingFee: "El monto de reembolso aquí no incluye la tarifa de procesamiento de reembolso y la tarifa de IVA. Verifique la tarifa de procesamiento de reembolso y la tarifa de IVA en la página del boleto después de la actualización.",
    LoanInfo: "actualizar clave de OXXO ",
    SuggestInfo: "Informaciones de Sugerencia",
    LoanID: "Número del préstamo ",
    DueDate: "Fecha de pago ",
    Principal: "Monto de principal",
    ReceivedRepaymentOfPrincipal: "Ha devuelto el principal",
    GracePeriodInterest: "Interés de periodo de gracia",
    ReceivedRepaymentOfGracePeriodInterest:
      "Ha devuelto el interés de periodo de gracia",
    PenaltyAndExtraFeesThatShouldBePaid: "Interés de castigo",
    ReceivedRepaymentOfPenalty: "Interés de castigo pagada",
    AutoCallTime: "Tiempo de llamada",
    IsnotConnect: "Resultado de marcar",
    RemainingAmountDue: "Debe de pagar  ",
    OverdueDays: "días vencidos ",
    ActualRepaymentAmount: "Deposito pagado ",
    TotalRepaymentAmount: "Monto Total ",
    CollectionStaff: "Rocordatorio ",
    TargetContact: "Objeto de llamada ",
    CommunicationTools: "Modo de cobranza ",
    Contact: "Teléfono ",
    ContactTime: "Tiempo de llamada ",
    answerTime: "Tiempo de duración",
    endTime: "Tiempo de finalización ",
    hangupDirection: "Dirección de colgar ",
    hangupCause: "Razón de colgar ",
    isNotConnect: "Si conectado ",
    PromiseToPayTime: "Fecha de promesa ",
    Nickname: "Nombre de usuario",
    OnlineOrNot: "¿Estás en línea?",
    UnprocessedTime: 'tiempo sin procesar',
    Hour: 'Horas',
    MIN: 'Min',
    LastTimeWork: 'La última vez que procesó el billete',
    AreYouSure: "¿Estás seguro?",
    Sure: "Confirmar",
    Cancel: "Cancelar",
    DeductionOfPrincipal: "Descontar el monto de préstamo",
    InterestReduction: "Descontar los intereses",
    RecordCollectionResults: "Resultado de cobro",
    Connect: "Llamada atendida",
    NotConnected: "No contesta",
    LoanOrderNumber: "Número del préstamo",
    Collection: "Situación de recogida",
    PaymentRecord: "Registro de pago",
    RepaymentPlan: "Plan de pago",
    AutomaticOutgoingCallRecord: "Registro automático de llamadas salientes",
    RecordCollectionRecord: "Registro de recogida de registros",
    RepaymentIssueReport: "Solicitar congelación de intereses",
    ApplyForInterestFreeze: "Apply for an interest freeze",
    PrincipalReduction: "Reducción de capital",
    CommitmentRepaymentTime: "Tiempo de reembolso del compromiso",
    Reminder: "Recordatorio",
    CallObject: "Objeto de llamada",
    CollectionMethod: "Método de recogida",
    ContactNumber: "número de contacto",
    PhoneCallTime: "Tiempo de llamada telefónica",
    ResponseTime: "Tiempo de respuesta",
    EndTime: "Hora de finalización",
    OnhookDirection: "Dirección para colgar",
    ReasonForHangingUp: "Razón para colgar",
    WhetherToDial: "Ya sea para marcar",
    ReasonForNotReturning: "Motivo para no regresar",
    WillingnessToRepay: "Voluntad de pagar",
    ReasonForNotConnecting: "Motivo para no conectarse",
    Result: "resultado",
    Recording: "grabación",
    AutomaticOutgoingTime: "Tiempo de salida automática",
    WhetherToCommunicate: "Ya sea para comunicarse",
    EnterThePartialRepaymentAmount:
      "Ingresa el monto del pago parcial según comunicación con el cliente",
    Attention: "Atención",
    RemainingAmountOfTheOrder: "monto restante a pagar de la reserva",
    OrderId: "ID de reserva",
    ActualPaymentDate: "Fecha de pago real",
    ActualRepaymentPrincipal: "Principal de reembolso real",
    RemissionDay: "Día de remisión",
    ReferralDirector: "Director de remisión",
    TheRemainingPrincipalCanBeReduced: "El principal restante se puede reducir",
    Reason: "razón",
    ActualInterestPaidDuringGracePeriod:
      "Intereses reales pagados durante el período de gracia",
    PenaltyInterestActuallyPaid: "Penalidad realmente pagada",
    GracePeriodInterestRemissiond: "Interés del período de gracia Remitido",
    RemissiondPenaltyInterest: "Remisión de intereses de penalización",
    TheRemainingPenaltyInterestCanBeRemission:
      "El interés de penalización restante puede ser Remisión",
    RemissionOfGracePeriodInterest:
      "Remisión de intereses del período de gracia",
    RemainingDeductibleInterestFromTheGracePeriod:
      "Interés deducible restante del período de gracia",
    auditResults: "Resultado de validación",
    auditor: "Validador",
    ticketHandleTime: "Tiempo de operación",
    ticketCompleteTime: "Tiempo de finalización",
    closeReason: "Motivo del cierre",
    viewTicket: "Ver el caso",
    repayStatus: "Estado de presentación de informes",
    repayStatus0: "Cuestiones de reembolso pendientes de tramitación por CS",
    repayStatus1: "Esperando la verificación bancaria / tripartita",
    repayStatus2: "Masalah pembayaran kembali yang dapat diunggah",
    tryCalc: "Hoja de cálculo",
  },
  Dialer: {
    Mobile: "Mobile",
    VA: "VA",
    userName: "Nombre de usuario",
    extnumber: "Número de la extensión ",
    assignStatus: "Estado de asignación ",
    assigned: "Asignado ",
    unassigned: "No asignado ",
    assign: "asignar",
    assignHistory: "asignar historial",
    supplier: "Proveedor ",
    InquiryExtensionNumberStartRange: "Busca el alcance de la extensión ",
    InquiryExtensionNumberEndRange: "Última llamada ",
    addTime: "Tiempo para Añadir ",
    addTheExtensionNumber: "Añadir una extensión ",
    deleteExtensionNumber: "Eliminar una extensión ",
    submit: "entregar ",
    roleList: "Lista de Roles ",
    unassign: "Cancelar la asignación ",
    assignStaff: "Empleados asignados ",
    staffID: "ID de empleados ",
    assignTime: "Tiempo de Asignación ",
    unassignTime: "Cancelar el tiempo de Asignación ",
    calledNumber: "Número de destino",
    explicitNumber: "Número mostrado",
    creationTime: "Tiempo de creación",
    outboundTime: "Tiempo de la llamada ",
    outboundChannels: "Canal de llamada",
    talkTime: "Tiempo de duración",
  },
  systemAttribute: {
    attributeName: "属性名",
    attributeDescription: "Descripción de propiedad",
    parameterValue: "Valor de atributo",
    submit: "提交",
    NewSystemParameters: "Crear un parámetro"
  },
  phoneVerify: {
    workStatus: "Estado",
    isAttendance: "Asistencia",
    batchOperations: "Operación masiva",
    orderTime: "Hora de inicio",
    PVCommissioner: "Ejecutivo de PV",
    IRCommissioner: "Ejecutivo de IR",
    batchOrders: "Recibir los casos",
    batchStopOrders: "Cancelar la asignación",
    stopAcceptTicket: "No recibe los casos",
    continueAcceptTicket: "Recibir los casos"
  },
  userInfo: {
    identityInformation: "informanción personal",
    name: "Nombre de cliente",
    gender: "Género",
    IDType: "Tipo de ID",
    IDNumber: "Número de ID",
    mobileNumber: "Celular",
    email: "Correo electronico",
    versionName: "Número de versión de Cliente(In",
    versionCode: "Número de versión en GP",
    imageData: "Datos imagenes",
    IDPhoto: "Foto de ID",
    handheldPhoto: "Foto de cliente con ID en la mano",
    otherInformation: "Otras informaciones",
    personalInfomation: "Información personal",
    marriageStatus: "Estado civil",
    birthday: "Fecha de nacimiento",
    numberOfChildren: "Hijos",
    currentAddress: "Domicilio actual",
    detailAddress: "Domicilio con las detalles",
    educationStatus: "Educación",
    famialyPhone: "Número telefinico fijo",
    disbursementType: "收款方式",
    bankName: "Nombre dek banco",
    bankNumber: "Número del banco",
    workInformation: "Información laboral",
    workType: "Tipo del trabajo",
    monthlyIncome: "Ingreso mensual",
    lengthOfWork: "工作多久",
    companyPhoneNumber: "Número de la empresa",
    companyName: "Nombre de la empresa",
    companyAddress: "Company Address",
    salaryDay: "Día de pago del salario",
    contactInformation: "Información del Contacto",
    contact1Name: "Contacto 1Nombre",
    contact1Relationship: "Contact Relationship1",
    phone: "Teléfono",
    contact2Name: "Contacto 2Nombre",
    contact2Relationship: "Contact Relationship2",
    communicationTime: "Tiempo de comunicación",
    communicator: "Comunicador",
    contents: "Contenido de comunicación",
    remark: "Nota",
    loanHistory: "ID de préstamo",
    loanAmount: "Monto del Préstamo",
    loanTerms: "Días de Plazo",
    loanStatus: "Estado del préstamo",
    applyTime: "Tiempo de Solicitud",
    processingTime: "Tiempo de aprobación",
    loanTime: "Tiempo de préstamo",
    amountNumber: "Importe del préstamo",
    closingTime: "Tiempo de cierre",
    overdueDays: "Días atrasados",
    ChangeHistory: "Cambia la historia",
    BorrowingHistory: "Préstamo de historia",
    AccountNumber: "número de cuenta",
    UpdateItems: "actualizar elementos",
    OriginalValue: "Valor original",
    TheCurrentValue: "El valor actual",
    TimeChange: "Cambio de tiempo",
    ModifiedBy: "Modificado por",
    TheTerm: "el termino",
    State: "Estado",
    BillingMessage: "Mensaje de facturación"
  },
  menu: {
    PaymentCodeList: "Lista de Ref.de pago",
    PaymentCodeHistory: "código de pago histórico",
    AuthoritySystem: "Sistema de autoridad",
    UserManagement: "Gestión de usuarios",
    RoleManagement: "administraciónDeRoles",
    AuthorityManagement: "gestión de autoridad",
    RolegroupManagement: "administraciónDeGruposDeRoles",
    GroupRightsManagement: "Gestión de derechos grupales",
    SystemParameterConfiguration: " Propiedades de parámetro",
    PhoneVerifySystem: "Administración de crédito",
    StaffManagement: "Administración de empleados",
    QuestionLibraryConfig: "Configuración de biblioteca de preguntas de auditoría",
    CaseClassification: "Clasificación de casos",
    CollectTicketSystem: "Sistema de cobranza",
    TicketManage: "Administración de Casos",
    RecordingQuality:'Lista de inspección de calidad de registro',
    QualityInspectionRecording:'Gestión del orden de trabajo',
    AttributeConfigure: " Propiedades de configuración",
    TicketBasicAttribute: "Propiedades basicas de Reserva",
    TicketCombineAttribute: "Propiedad combinada de Reserva",
    LoadAttributeConfigure: "Cargo Propiedades de configuración",
    RuleConfiguration: "Configuración de la regla",
    GenerationRule: "Regla de generación",
    DistributionRules: "Reglas de distribución",
    RecyclingRules: "Reglas de reciclaje",
    OutsourcingRules: "Reglas de outsourcing",
    WorkOrderProcessingList: "Lista de procesamiento de órdenes de trabajo",
    Collection: "Cobranza",
    RepaymentReminder: "Recordatorio de reembolso",
    DialerManagement: "Gestión de marcador",
    VoipManagement: "gestión de voip",
    NxManagement: "configuración de NX",
    ExtensionManagement: 'Gestión de extensiones',
    PerformanceManagement: "Gestión del rendimiento",
    PersonalPerformance: "Desempeño personal",
    PersonalPerformance2: "Datos de Cobranza por Hora",
    PerformanceComparison: "Comparación de rendimiento",
    DistributeHistory: "Historial de asignación",
    CollectionSystem: "C2 Plataforma de Crédito ",
    callRecords: "registros de llamadas",
    PaymentCodeInquire: "Busca la referencia",
    salaryReport: "reporte de salario",
    Applyapprove: "Solicita la aprobación ",
    TelemarketingTicketSystem: "Sistema de Venta",
    CorpusAnnotation:'anotación de corpus',
    CorpusAnnotationDetail:'Detalles de la anotación del corpus',

    CorpusAnnotationList:'Lista de anotaciones de corpus',
    StaffBasicProperty: "Propiedad básica del personal",
    StaffCombProperty: "Propiedad combinada del personal",
    Dashboard: "Tablero",
    DashboardScreen: "Pantalla del tablero",
    LoggingManagement: "Gestión de registros",
    SystemOperationLog: "Registro de operaciones del sistema",
    ThirdPartyRequestLog: "Registro de solicitudes de terceros",
    pageTips: 'Todas las acciones que realice se registrará en el sistema, no utilice la información de la empresa de forma privada, ¡Se reserva el derecho de ejercer todas aquellas acciones legales en caso de incumplimiento!'
  },
  lang: {
    Spanish: "Español",
    Chinese: "中文",
    English: "English",
    Vietnam: "Tiếng Việt",
    Arabic:' بالعربية ',
    indo: "bahasa Indonesia",
  },
  v0703: {
    Caseid: "Identificación del caso",
    TicketOperate: "boleto de operar",
    PleaseEnterOrSelectRole: "Por favor ingrese o seleccione un rol",
    CreationTime: "tiempo de creación ",
    LoadAttributesName: "Nombre de atributos de carga",
    PleaseEnterOrSelectAnAttributes:
      "Por favor ingrese o seleccione un atributo",
    LoadAttributesNumber: "Número de atributos de carga",
    LoadAttributesDescription: "Descripción de los atributos de carga",
    LoadAttributesType: "Tipo de atributos de carga",
    CombinedPropertyName: "Nombre de propiedad combinada",
    NumericalValue: "Valor numérico",
    Options: "Opciones",
    Time: "Hora",
    CrowdOrder: "Orden de la multitud",
    Save: "salvar",
    PleaseEnter: "Por favor escribe",
    TicketUnassign: "boleto no asignado",
    ViopNumberUnassign: "Anular asignación",
    NewAddition: "Nueva adquisición",
    TicketAssignStaff: "ticket asignar personal",
    TicketStaffId: "identificación del personal de boletos",
    TicketUnassignTime: "tiempo de asignación de boletos",
    ByDay: "Buscar por día",
    Hour: "Buscar por hora",
    ParameterValue: "Valor del parámetro"
  },
  v0707: {
    FirstsubsequentLoan: "Primer préstamo /préstamos consecuentes",
    FirstLoan: "Primer préstamo",
    Reloan: "segundo préstamo",
    Yes: "si",
    No: "No"
  },
  annotation: {
    AnnotationManagement: "标注管理",
    AnnotationTicketManagement: "标注工单管理",
    AnnotationTicketList: "标注工单列表",
  },
  smsPushTask: {
    multilingualTitle: "Título multilingüe",
    multilingualContent: "Contenido multilingüe",
    multilingualStatus: "Estado multilingüe",
    label: "Etiquetas",
    state: "Estado",
    addMultilingual: "Añadir operación multilingüe",
    multilingualDesc: "Descripción multilingüe",
    relateSmsTask: "Tareas relacionadas con SMS",
    relatePushTask: "Tareas relacionadas con push",
    operator: "Operador",
    changeState: "Modificar el estado",
    editContent: "Editar contenido",
    addMultilingualContent: "Añadir contenido multilingüe",
    selectLanguage: "Seleccionar idioma",
    varLibrary: "Base de variables",
    multiContentManage: "Gestión de contenido multilingüe",
  },
  ...enLocale,
  ...performanceEs,
  ...JSON.parse(trans),
  ...JSON.parse(hom),
  ...langEs,
  ...fhbLangEs,
  ...wrhLangEs,
  ...lxyLangEs,
  ...DyLangEs,
  ...lssLangEs,
};

export default es;
